import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { deleteCollaborator } from "../services/roleApi";
import toast from "react-hot-toast";
import { ModalFooter } from "reactstrap";

const DeleteCollaboratorModal = ({ show, onClose, collaborator, onDeleted }) => {
  const [confirmStep, setConfirmStep] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await deleteCollaborator(collaborator.id);
      toast.success("Collaborateur supprimé ✅");
      onDeleted(); // rafraîchir la liste
      setLoading(false);
      setConfirmStep(false);
      onClose();
    } catch (error) {
      setLoading(false);
      toast.error("Erreur lors de la suppression ❌");
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <div style={{ padding: "0 10px" }}>
        <div className="titles mb-3">
          {confirmStep ? "Confirmation finale" : "Supprimer un collaborateur"}
        </div>
        <Modal.Body>
          {!confirmStep ? (
            <p>
              Voulez-vous vraiment <b>supprimer</b> le collaborateur{" "}
              <span style={{ color: "red" }}>{collaborator?.fullName}</span> ?
            </p>
          ) : (
            <p>
              ⚠️ Cette action est <b>définitive</b>. Confirmez-vous la suppression
              du collaborateur{" "}
              <span style={{ color: "red" }}>{collaborator?.fullName}</span> ?
            </p>
          )}
            <div style={{ display:'flex',justifyContent: "flex-end", gap: "10px",padding:"10px 0" }}>
          <Button variant="secondary" onClick={onClose}>
            Annuler
          </Button>
          {!confirmStep ? (
            <Button variant="danger" onClick={() => setConfirmStep(true)}>
              Oui
            </Button>
          ) : (
            <Button variant="danger" onClick={handleDelete} disabled={loading}>
              {loading ? "Suppression..." : "Confirmer"}
            </Button>
          )}
        </div>
        </Modal.Body>
      
      </div>
    </Modal>
  );
};

export default DeleteCollaboratorModal;
